import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Raj Narayan Gupta</span>
            from <span className="purple"> Patna, Bihar.</span>
            <br />
            I am a solutions-driven Full Stack Developer, currently working as a <span className="purple">Dotnet Angular Developer</span> at Web Aspirations.
            <br />
            I am pursuing a Master of Computer Applications (M.C.A) from Patliputra University and hold a Bachelor of Computer Applications (B.C.A) from the same university.
            <br />
            <br />
            With over 5 years of experience, I specialize in building scalable web and desktop applications using a wide range of technologies including .NET Core, C#, Blazor, Angular, and ReactJS. I am passionate about creating high-quality, user-centered solutions and continuously exploring new technologies.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
